import { useContext, useRef, useState } from "react";
import { validateEmail } from "../../../../utils/validators";
import { useAppDispatch, useAppSelector } from "../../../../../common/store";
import { postCallbackForm } from "../../../../../common/store/chat/thunks/post-callback-form";
import Container from "./styles";
import { v4 } from "uuid";
import { sendMessageLogSubmission } from "../../../../../common/store/chat/thunks/send-message-log";
import VurbalizeEvents from "../../../../../common/types/dto/chat/vurbalize-events";
import getMessageByVurablizeEvent from "../../../../utils/get-message-by-vurablize-event";
import { closeBookAppointment } from "../../../../../common/store/theme/theme-slice";
import { getChatMessages } from "../../../../../common/store/chat/thunks/get-chat-messages";
import { ChatContext } from "../../../../contexts/chat-context";

const CallbackForm = () => {
  const [formData, setFormData] = useState<Record<string, any>>({});
  const [formValid, setFormValid] = useState(false);
  const [showError, setShowError] = useState('');
  const formValidRef = useRef(false);
  const dispatch = useAppDispatch();
  const fields = useAppSelector(state => state.theme.themeConfig.callbackForm) || [];
  const { sendMessageToServer } = useContext(ChatContext);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    var data = { ...formData, [name]: value }
    setFormData(data);
    handleValidation(data); 
  };

  const handleValidation = (data:any) => {
    let isValid = true;
    fields.forEach((field:any) => {
      if (field.required && !data[field.name]) {
        isValid = false;
      }
    });
    formValidRef.current = isValid;
    setFormValid(isValid)
  };

  const handleSubmit = async (e:any) => {
    e.preventDefault();
    setFormValid(false);

    const { email } = formData;
    if (!validateEmail(email)) {
      setShowError("Invalid email address.")
      setFormValid(true);
      return;
    }

    const submittedData = await Object.entries(formData).map(([name, value]) => {
      const label = document.querySelector(`label[for="${name}"]`)?.textContent?.trim() || '';
      return { label, name, value };
    });

    await dispatch(postCallbackForm({ formData: submittedData }));
    dispatch(closeBookAppointment());
  };

  const onClose = async() => {
    dispatch(closeBookAppointment());
    dispatch(sendMessageLogSubmission({ data: {
      message: getMessageByVurablizeEvent(VurbalizeEvents.CALLBACK_UI_EVENT),
      event_name: VurbalizeEvents.CALLBACK_UI_EVENT,
      turn_id: v4(),
    }}))
    if (sendMessageToServer) {
      sendMessageToServer({ message: "Operator:[User closed callback form]" });
      dispatch(getChatMessages());
    }
  }

  return (
    <Container>
      <div className="voa_close_59o7kg" onClick={onClose}>
        &times;
      </div>

      <div className="error">
        {showError}
      </div>
      <div className="callback-widget-header">
        <h3>CONTACT INFO</h3>
      </div>

    <form onSubmit={handleSubmit}>
      {fields.map((field:any) => (
        <div key={field.name} className="field_section">
          <label htmlFor={field.name}>{field.label}
          {field.required === true &&
            <span className="required">*</span>
          }
          </label>
          {field.type === 'text' && (
            <input
              type="text"
              id={field.name}
              name={field.name}
              value={formData[field.name] || ''}
              onChange={handleChange}
              required={field.required}
            />
          )}
          {field.type === 'email' && (
            <input
              type="email"
              id={field.name}
              name={field.name}
              value={formData[field.name] || ''}
              onChange={handleChange}
              required={field.required}
            />
          )}
          {field.type === 'phone' && (
            <input
              type="tel"
              id={field.name}
              name={field.name}
              value={formData[field.name] || ''}
              onChange={handleChange}
              required={field.required}
              pattern="^[+]\d{9,15}$"
            />
          )}
          {field.type === 'textarea' && (
            <textarea
              id={field.name}
              name={field.name}
              value={formData[field.name] || ''}
              onChange={handleChange}
              required={field.required}
            />
          )}
        </div>
      ))}
      <div>
        <button type="submit" disabled={!formValid}>Submit</button>
      </div>
    </form>
    </Container>
  );

}

export default CallbackForm;
